import {
  Component,
  OnDestroy,
  ViewContainerRef,
} from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { Subscription } from 'rxjs'
import { INVESTMENT_MINIMUM_FILTERS } from 'src/app/models/filter-details.model'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'
import { FiltersService } from 'src/app/services/filtersService.service'

@Component({
  selector: 'investment-minimum-filter',
  templateUrl: './investmentMinimumFilter.component.html',
  styleUrls: ['./investmentMinimumFilter.component.scss'],
  providers: [],
})
export class InvestmentMinimumFilterComponent implements OnDestroy {
  // AEM content Vars
  investmentMinimum: AEMChunk
  aemContentSub: Subscription

  // eslint-disable-next-line max-params
  constructor(
    private readonly filtersService: FiltersService,
    private readonly viewContainer: ViewContainerRef,
    private readonly centralContentService: CentralContentService,
  ) {}
    
  public readonly investmentMinimumFilters: string[] = INVESTMENT_MINIMUM_FILTERS
  public investmentMinimumGroup: UntypedFormGroup
  public readonly minimumsMap = {
    '1-1000': '$1 - $1,000',
    '1000-3000': '$1,000 - $3,000',
    '3000-10000': '$3,000 - $10,000',
    '10000-25000': '$10,000 - $25,000',
    '25000-50000': '$25,000 - $50,000',
    '50000>': '$50,000 >',
    closed: 'Closed funds',
  }
  ngOnInit() {
    this.investmentMinimumGroup = this.filtersService.activeFilters.investmentMinimums
    this.investmentMinimumGroup.valueChanges.subscribe(() => {
      this.filtersService.applyFilters()
    })
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
  }

  parseAEMContent(content) {
    this.investmentMinimum = this.centralContentService.getContentByBody(
      'fund_definitions_whats_an_investment_minimum',
      content,
    )
  }

  formatLink(str) {
    const from = ['&lt;', '&gt;', '&amp;', '&quot;', '>nbsp;']
    const to = ['<', '>', '&', '"', ' ']
    from.forEach((data, index) => {
      str = this.regularExpression(str, data, to[index])
    })
    return str
  }
  regularExpression(str, find, replace) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const escapedFind = find.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1')
    return str.toString().replace(new RegExp(escapedFind, 'g'), replace)
  }
  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }
}
